module.exports = __webpack_public_path__ + "_/assets/images/white-owl-cw-62218d7ae897c1c12dfdebbf3177a3ca.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/white-owl-cw.png
// module id = 863
// module chunks = 10 11